import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import  { useState } from "react";
import {  faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import { Button,  Modal, Spinner } from 'react-bootstrap';
import RegisterTextbox from '../../components/RegisterTextBox';
import TableComponent from '../../components/TableComponent';
import API from '../../api/axiosConfig';
import { useNavigate } from 'react-router';

function KPI() {
    const columns = [
        { name: "السؤال", key: "quiz" },
        { name: "القيمة المتوقعة", key: "target" },
        { name: "", key: "actions" },
    ];
    const [rows, setRows] = useState([])
    const [error, setError] = useState([])
    const [quiz, setQuiz] = useState('')
    const [target, setTarget] = useState(0)
    const [showModal, setShowModal] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [tableReloadKey, setTableReloadKey] = useState(Date.now());

    
    const handlekpi = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        const formData = new FormData();
        formData.append('quiz', quiz);
        formData.append('target', target);

        try {
            const res = await API.post(`/kpi/store`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const data = await res;
            if (data.status === 200) {
                setQuiz('');
                setTarget(0);
                setError([]);

                setShowModal(false);
                setIsSubmitting(false);
                setRows(data.data);
                setTableReloadKey(Date.now());
            }
        } catch (error) {
            console.error(error);
            setIsSubmitting(false);
            setError(error.response?.data?.errors || {});
        }
    };

    const dropdownOptions = [
        { label: "حذف", action: (id) => {
            if (window.confirm("هل أنت متأكد من حذف هذا المؤشر")) {
                API.get(`/kpi/${id}/delete`)
                    .then((res) => {
                        if (res.status === 200) {
                            setTableReloadKey(Date.now());
                        }
                    })
                    .catch((error) => {
                        console.error("There was an error!", error);
                    });
            }
        } },
    ];

    return (
        <>
            <div className="printcasedata-container">

                <div className="archive-report">
                    <span className="add-row-ta archiveAdd" onClick={() => setShowModal(true)}>
                        <FontAwesomeIcon icon={faPlus} /> إضافة
                    </span>
                </div>

                <TableComponent
                    apiUrl="/kpi"
                    columns={columns}
                    title=" مؤشرات الاداء"
                    triggerReload={tableReloadKey}
                    dropdownOptions={dropdownOptions}
                />
            </div>
            <Modal
                show={showModal}
                onHide={() => setShowModal(false)}
                className="modal-table small-modall archModal archive-modal"
                  dialogClassName="fit-content-modal"

            >
                <Modal.Header>
                    <Modal.Title>إضافة مؤشر</Modal.Title>
                    <Button
                        className="custom-close-button"
                        variant="link"
                        onClick={() => setShowModal(false)}
                    >
                        <FontAwesomeIcon icon={faXmark} className="closeModal" />
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <RegisterTextbox label="المؤشر" type="text" value={quiz} onChange={(e) => setQuiz(e.target.value)} />
                    {error && error.quiz && <span className="error">{error.quiz[0]}</span>}
                    <RegisterTextbox label="القيمة المتوقعة" type="number" value={target} onChange={(e) => setTarget(e.target.value)} />
                    {error && error.target && <span className="error">{error.target[0]}</span>}
                   

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        إغلاق
                    </Button>
                    {
                        isSubmitting ? (
                            <Button variant="primary" disabled>
                                <Spinner animation="border" size="sm" />
                            </Button>
                        ) : (
                            <Button variant="primary" onClick={handlekpi}>
                                حفظ
                            </Button>
                        )
                    }
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default KPI;
